import { Card, TabPane } from "react-bootstrap";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import StaffHappycallGrades from "../Components/Happycall/StaffHappycallGrades";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import ProductHappycallGrades from "../Components/Happycall/ProductHappycallGrades";
import ReceptionHappycallGrades from "../Components/Happycall/ReceptionHappycallGrades";
import AgencyHappycallGrades from "../Components/Happycall/AgencyHappycallGrades";
import IranHappycallGrades from "../Components/Happycall/IranHappycallGrades";
import CityHappycallGrades from "../Components/Happycall/CityHappycallGrades";
import ServiceHappycallGrade from "../Components/Happycall/ServiceHappycallGrades";
import TotalHappycallGrades from "../Components/Happycall/TotalHappycallGrades";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartBar } from "@fortawesome/free-solid-svg-icons";

export default function HappycallGrades() {
    const dispatch = useDispatch();
    const settingNames = ['ProductGrouppingType', 'Happycall_AlarmZone_Zaeef', 'Happycall_AlarmZone_MotavasetBePaeen', 'Happycall_AlarmZone_Motavaset', 'Happycall_AlarmZone_MotavasetBeBala'];

    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-مشتریان";
        dispatch(getSystemSettings(settingNames));
    })
    return (
        <div className="container-fluid mt-1" style={{ minHeight: '80vh', textAlign: "right" }}>
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faChartBar} size="lg" />&nbsp;
                    گزارش عملکرد</Card.Header>
                <Card.Body className="bodyStyle">
                    <Tabs>
                        <TabList>
                            <Tab>عملکرد تکنسین</Tab>
                            <Tab>عملکرد محصول</Tab>
                            <Tab>عملکرد اپراتور</Tab>
                            <Tab>عملکرد نماینده</Tab>
                            <Tab>عملکرد شهرستان</Tab>
                            <Tab>عملکرد کشوری</Tab>
                            <Tab>عملکرد مقیاس</Tab>
                            <Tab>عملکرد کلی</Tab>
                        </TabList>
                        <TabPanel>
                            <StaffHappycallGrades />
                        </TabPanel>
                        <TabPanel>
                            <ProductHappycallGrades />
                        </TabPanel>
                        <TabPanel>
                            <ReceptionHappycallGrades />
                        </TabPanel>
                        <TabPanel>
                            <AgencyHappycallGrades />
                        </TabPanel>
                        <TabPanel>
                            <CityHappycallGrades />
                        </TabPanel>
                        <TabPanel>
                            <IranHappycallGrades />
                        </TabPanel>
                        <TabPanel>
                            <ServiceHappycallGrade />
                        </TabPanel>
                        <TabPanel>
                            <TotalHappycallGrades />
                        </TabPanel>
                    </Tabs>
                </Card.Body>
            </Card>
        </div>
    )
}